export const Subdomains = {
  APP: 'app',
  APP_API: 'app-api',
} as const;
